(() => {
  function connectHomepage() {
    const reviews = document.querySelector('[id$="__1784251805255205f4"]');
    if (reviews && !reviews.querySelector('#a1-home-reviews')) {
      const anchor = document.createElement('div');
      anchor.id = 'a1-home-reviews';
      reviews.prepend(anchor);
    }
    const form = document.querySelector('.a1-home-finder__form');
    const preview = new URLSearchParams(location.search).get('preview_theme_id');
    if (form && preview && !form.elements.namedItem('preview_theme_id')) {
      const input = document.createElement('input');
      input.type = 'hidden'; input.name = 'preview_theme_id'; input.value = preview;
      form.append(input);
    }
    document.querySelectorAll('a[href="#a1-fit-promise"]').forEach(link => {
      if (link.dataset.a1Connected) return;
      link.dataset.a1Connected = 'true';
      link.addEventListener('click', () => { const details = document.getElementById('a1-fit-promise'); if (details) details.open = true; });
    });
  }
  connectHomepage();
  document.addEventListener('shopify:section:load', connectHomepage);
})();
